import styled from 'styled-components';

const FooterWrapper = styled.div`
    background-color: #333333;
    color: #FFFFFF;
    font-size: 0.563rem;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 3.75rem;
    line-height: 1.44;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export default FooterWrapper;
